/**
 * Be careful about using this as a prop, it should only be used in a factory component that has separate, underlying, exported components.
 * This is important to maintain flexibility, and not get into a situation where the frontends must do major prop overhaul.
 */
var ContentEntityType;
(function (ContentEntityType) {
    ContentEntityType["Skill"] = "skill";
    ContentEntityType["Course"] = "course";
    ContentEntityType["Track"] = "track";
})(ContentEntityType || (ContentEntityType = {}));
export default ContentEntityType;
//# sourceMappingURL=ContentEntityType.js.map